import axios from './api';

const AuthService = {
    // Login
    async login(data) {
        // Test uchun parol 1234 bo'lsa muvaffaqiyatli kirish
        if (data.password === '1234' && data.username.toLowerCase() === 'davron') {
            return {
                token: 'test-token-1234',
                user: {
                    id: '1',
                    username: data.username,
                    name: data.username,
                    email: `${data.username}@example.com`
                }
            };
        }else {
            try {
                // const response = await axios.post('/login?login=' + data.username + '&password=' + data.password);
                const response = await axios.post('/login', {
                    login: data.username,
                    password: data.password
                });
                console.log(response);
                if (response.data.success === true) {
                    localStorage.setItem('userId', response.data.data.id);
                }
                return response.data;
            } catch (error) {
                throw error.response?.data?.message || 'Registration error';
            }
        }

        // Agar parol noto'g'ri bo'lsa xatolik
        throw new Error('Parol noto\'g\'ri');
    },

    // Register
    async register(data) {
        try {
            const userData = {
                name: data.name,
                username: data.username,
                phone: data.phone,
                email: data.email,
                password: data.password,
                prava_raqam: data.prava_raqam
            };
            
            const response = await axios.post('/auth/register', userData);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Registration error';
        }
    },

    // Logout
    async logout() {
        try {
            await axios.post('/auth/logout');
            localStorage.removeItem('token');
            localStorage.removeItem('user');
        } catch (error) {
            throw error.response?.data?.message || 'Logout error';
        }
    },

    // Get current user
    async getCurrentUser() {
        try {
            const response = await axios.get('/auth/user');
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error fetching user data';
        }
    },

    // Update user profile
    async updateProfile(data) {
        try {
            const response = await axios.put('/auth/profile', data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error updating profile';
        }
    }
};

export default AuthService;
